export default __webpack_public_path__ + "static/media/switchToScreenSharing.900d9338.svg";